
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ComparisonContent from '@/components/comparison/ComparisonContent';
import PageTransition from '@/components/PageTransition';
import { useLanguage } from '@/contexts/LanguageContext';
import { updateMetaTags, getCanonicalUrl } from '@/utils/seoUtils';
import { translations } from '@/utils/translations';

const Comparison = () => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];
  
  useEffect(() => {
    // SEO meta tags setup
    const titlesByLang = {
      de: "KI-Videomarketing vs. traditionelle Videoproduktion | Future Level",
      en: "AI Video Marketing vs. Traditional Video Production | Future Level",
      fr: "Marketing Vidéo IA vs. Production Vidéo Traditionnelle | Future Level",
      it: "Marketing Video IA vs. Produzione Video Tradizionale | Future Level"
    };
    
    const descriptionsByLang = {
      de: "Vergleich zwischen KI-generierter Videoproduktion und traditioneller Videoproduktion - Kosten, Zeit, Qualität und ROI im Überblick",
      en: "Comparison between AI-generated video production and traditional video production - costs, time, quality and ROI overview",
      fr: "Comparaison entre la production vidéo générée par IA et la production vidéo traditionnelle - aperçu des coûts, du temps, de la qualité et du ROI",
      it: "Confronto tra produzione video generata da IA e produzione video tradizionale - panoramica su costi, tempo, qualità e ROI"
    };
    
    const keywordsByLang = {
      de: "KI-Videomarketing vs traditionell, KI-Videos Kosten, Videoproduktion Vergleich, KI-Videoproduktion Vorteile, traditionelle Videoproduktion Nachteile, KI vs menschliche Videoerstellung, ROI Videomarketing",
      en: "AI video marketing vs traditional, AI videos cost, video production comparison, AI video production advantages, traditional video production disadvantages, AI vs human video creation, ROI video marketing",
      fr: "Marketing vidéo IA vs traditionnel, coût vidéos IA, comparaison production vidéo, avantages production vidéo IA, inconvénients production vidéo traditionnelle, IA vs création vidéo humaine, ROI marketing vidéo",
      it: "Marketing video IA vs tradizionale, costo video IA, confronto produzione video, vantaggi produzione video IA, svantaggi produzione video tradizionale, IA vs creazione video umana, ROI marketing video"
    };
    
    const pagePath = currentLanguage === 'de' ? '/ki-videomarketing-vs-traditionelle-produktion' : 
                    currentLanguage === 'en' ? '/ai-video-marketing-vs-traditional-production' : 
                    currentLanguage === 'fr' ? '/video-marketing-ia-vs-production-traditionnelle' : 
                    '/marketing-video-ia-vs-produzione-tradizionale';
    
    const canonicalUrl = getCanonicalUrl(pagePath.substring(1), currentLanguage);
    
    updateMetaTags({
      title: titlesByLang[currentLanguage as keyof typeof titlesByLang],
      description: descriptionsByLang[currentLanguage as keyof typeof descriptionsByLang],
      keywords: keywordsByLang[currentLanguage as keyof typeof keywordsByLang],
      canonicalUrl: canonicalUrl,
      language: currentLanguage,
      ogType: "article"
    });
    
  }, [currentLanguage, t]);
  
  return (
    <div className="flex flex-col min-h-screen bg-[#121212]">
      <Header />
      <PageTransition>
        <main className="flex-grow pt-24">
          <ComparisonContent />
        </main>
      </PageTransition>
      <Footer />
    </div>
  );
};

export default Comparison;
